import { css } from "@compiled/react";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";

export interface UserTierProps {
    unitLimitLower: number;
    unitLimitUpper: number;
    numberFormatLocale?: "en-US" | "ja-JP";
    unitType?: "user" | "agent";
}
export const UserTier = (props: UserTierProps) => {
    const {
        unitLimitLower,
        unitLimitUpper,
        numberFormatLocale = "en-US",
        unitType
    } = props;
    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;

    if (unitType === "agent") {
        return (
            <FormattedMessage
                id="PricingCalculator.agentTier.range"
                defaultMessage="Agent tier: {lowerLimit} - {upperLimit}"
                values={{
                    lowerLimit: formatNumber(unitLimitLower),
                    upperLimit: formatNumber(unitLimitUpper)
                }}
            />
        );
    }

    return (
        <FormattedMessage
            id="PriceFunder.userTier.range"
            defaultMessage="User tier: {lowerLimit} - {upperLimit}"
            values={{
                ...DEFAULT_VALUES,
                lowerLimit: formatNumber(unitLimitLower),
                upperLimit: formatNumber(unitLimitUpper)
            }}
        />
    );
};

export interface UserTierExpandedProps {
    unitLimitLower: number;
    unitLimitUpper: number;
    unitsInTier: number;
    unitsAvailableInTier: number;
    numberFormatLocale?: "en-US" | "ja-JP";
}
export const UserTierExpanded = (props: UserTierExpandedProps) => {
    const {
        unitLimitLower,
        unitLimitUpper,
        unitsInTier,
        unitsAvailableInTier,
        numberFormatLocale = "en-US"
    } = props;

    const intl = useIntl();

    const formatNumber = new Intl.NumberFormat(numberFormatLocale).format;

    return (
        <div
            css={css({
                fontSize: "14px",
                padding: "0 16px"
            })}
        >
            <p>
                {intl.formatMessage(messages.tier)}
                <br />
                {formatNumber(unitLimitLower)} - {formatNumber(unitLimitUpper)}
            </p>
            <p>
                {intl.formatMessage(messages.filledSeats)}
                <br />
                {formatNumber(unitsInTier)}
            </p>
            <p>
                {intl.formatMessage(messages.availableSeats)}
                <br />
                {formatNumber(unitsAvailableInTier)}
            </p>
        </div>
    );
};

const messages = defineMessages({
    tier: {
        id: "PriceFinder.userTier.tier",
        defaultMessage: "Tier:"
    },
    filledSeats: {
        id: "PriceFinder.userTier.filledSeats",
        defaultMessage: "Filled seats:"
    },
    availableSeats: {
        id: "PriceFinder.userTier.availableSeats",
        defaultMessage: "Available seats:"
    }
});
